module.exports = __webpack_public_path__ + "1f6f423b5fd4b482a76d85db81015c65.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/book-shelf.png
// module id = 1241
// module chunks = 0